(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["e11-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('e11-customer-reviews')) {
    customElements.define('e11-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.e11-cr__track');
        this.cards = [...this.querySelectorAll('.e11-cr__card')];
        this.controls = this.querySelector('.e11-cr__controls');
        this.buttons = [...this.querySelectorAll('[data-direction]')];
        this.progress = this.querySelector('.e11-cr__progress span');
        this.videos = [...this.querySelectorAll('video')];
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          if (this.controls) this.controls.hidden = max <= 2;
          this.buttons.forEach(button => { button.disabled = Number(button.dataset.direction) < 0 ? position <= 2 : position >= max - 2; });
          if (this.progress) this.progress.style.width = `${Math.min(100, (position + this.track.clientWidth) / Math.max(1, this.track.scrollWidth) * 100)}%`;
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const card = this.cards[0];
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({ left: step * Number(button.dataset.direction) * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options));
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.track);
        this.visibility = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: 0 });
        this.videos.forEach(video => {
          this.visibility.observe(video);
          video.addEventListener('play', () => this.videos.forEach(other => { if (other !== video) other.pause(); }), options);
        });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.videos.forEach(video => video.pause()); }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.e11-cr__card');
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
        }, options);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        this.videos?.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e11-halloween-accents"]) return;
  try {
    
  if (!customElements.get('e11-halloween-accents')) {
    customElements.define('e11-halloween-accents', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.parts = [];
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.mount(), { once: true, signal: this.controller.signal });
        else this.mount();
        document.addEventListener('shopify:section:load', () => this.mount(), { signal: this.controller.signal });
      }
      mount() {
        const main = document.querySelector('#MainContent');
        const template = this.querySelector('template');
        if (!main || !template) return;
        const sections = [...main.children].filter(el => el.classList.contains('shopify-section') && el.id !== 'shopify-section-e11-halloween-site');
        const targets = sections.filter((el, index) => index > 0 && (index - 1) % 3 === 0).slice(0, 6);
        targets.forEach((target, index) => {
          if (target.previousElementSibling?.classList.contains('e11-ha-break')) return;
          const accent = template.content.firstElementChild.cloneNode(true);
          accent.classList.add(['e11-ha-break--pumpkin', 'e11-ha-break--ghost', 'e11-ha-break--bunting'][index % 3]);
          target.before(accent);
          this.parts.push(accent);
        });
        const footer = document.querySelector('.shopify-section-group-footer-group');
        if (footer && !footer.previousElementSibling?.classList.contains('e11-ha-break--footer')) {
          const accent = template.content.firstElementChild.cloneNode(true);
          accent.classList.add('e11-ha-break--footer');
          footer.before(accent);
          this.parts.push(accent);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.parts?.forEach(part => part.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e11-halloween"]) return;
  try {
    
  if (!customElements.get('e11-halloween')) {
    customElements.define('e11-halloween', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.mount(), { once: true, signal: this.controller.signal });
        } else {
          this.mount();
        }
      }
      mount() {
        this.host = document.querySelector('#MainContent product-info[id^="MainProduct-"]');
        const template = this.querySelector('template');
        if (!this.host || !template || this.host.querySelector('.e11-halloween-frame')) return;
        this.host.classList.add('e11-halloween-host');
        this.parts = [...template.content.cloneNode(true).children];
        this.host.append(...this.parts);
        if (this.dataset.clicks !== 'true') return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = new Set();
        this.layer = document.createElement('div');
        this.layer.className = 'e11-halloween-particles';
        this.layer.setAttribute('aria-hidden', 'true');
        document.body.append(this.layer);
        this.lastBurst = -Infinity;
        const signal = this.controller.signal;
        this.host.addEventListener('click', event => {
          const trigger = event.target.closest('.e11-halloween-trigger');
          if (!trigger && event.target.closest('a,button,input,select,textarea,summary,form,dialog,[role="button"],[contenteditable]')) return;
          const rect = trigger?.getBoundingClientRect();
          this.burst(rect ? rect.left + rect.width / 2 : event.clientX, rect ? rect.top : event.clientY);
        }, { signal, passive: true });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.clear(); }, { signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.clear(); }, { signal });
      }
      burst(x, y) {
        const now = performance.now();
        if (this.motion.matches || document.hidden || now - this.lastBurst < 250 || this.layer.childElementCount > 32) return;
        this.lastBurst = now;
        const symbols = ['🎃', '👻', '🦇', '🍬', '✦'];
        const count = matchMedia('(max-width: 749px)').matches ? 7 : 10;
        for (let index = 0; index < count; index++) {
          const particle = document.createElement('span');
          particle.className = 'e11-halloween-particle';
          particle.textContent = symbols[index % symbols.length];
          this.layer.append(particle);
          const angle = Math.PI * 2 * index / count;
          const distance = 55 + Math.random() * 65;
          const dx = Math.cos(angle) * distance;
          const dy = Math.sin(angle) * distance - 55;
          const animation = particle.animate([
            { transform: `translate(${x - 12}px,${y - 12}px) scale(.35) rotate(0deg)`, opacity: 0 },
            { opacity: 1, offset: .14 },
            { transform: `translate(${x + dx}px,${y + dy}px) scale(1) rotate(${dx * 1.7}deg)`, opacity: 0 }
          ], { duration: 950 + Math.random() * 200, easing: 'cubic-bezier(.16,.7,.3,1)', fill: 'forwards' });
          this.animations.add(animation);
          const cleanup = () => { particle.remove(); this.animations.delete(animation); };
          animation.onfinish = cleanup;
          animation.oncancel = cleanup;
        }
      }
      clear() {
        if (this.animations) for (const animation of [...this.animations]) animation.cancel();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.clear();
        this.parts?.forEach(part => part.remove());
        this.layer?.remove();
        this.host?.classList.remove('e11-halloween-host');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e11-sale-popup"]) return;
  try {
    
  (() => {
    function initialize() {
      const dialog = document.getElementById('E11SalePopup');
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      const editor = Boolean(window.Shopify && window.Shopify.designMode);
      const storageKey = 'e11-sale-popup-20261010';
      const frequency = Number(dialog.dataset.frequency) || 86400000;
      const delay = Number(dialog.dataset.delay) || 1500;
      let oldOverflow, oldPadding, styleApplied = false;
      let stopped = false;
      function readSeen() {
        for (const kind of ['localStorage', 'sessionStorage']) {
          try { const timestamp = Number(window[kind].getItem(storageKey)); if (timestamp) return timestamp; } catch (_) {}
        }
        return 0;
      }
      function markSeen() {
        if (editor) return;
        for (const kind of ['localStorage', 'sessionStorage']) {
          try { window[kind].setItem(storageKey, String(Date.now())); return; } catch (_) {}
        }
      }
      dialog.querySelectorAll('.e11-sale-popup__close, .e11-sale-popup__continue').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        stopped = true;
        if (styleApplied) { document.body.style.overflow = oldOverflow; document.body.style.paddingRight = oldPadding; styleApplied = false; }
        markSeen();
      });
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', markSeen));
      if (!editor && Date.now() - readSeen() < frequency) return;
      const image = dialog.querySelector('img');
      let attempts = 0;
      function showWhenReady() {
        if (stopped || !dialog.isConnected || dialog.open) return;
        if (image.complete && !image.naturalWidth) return;
        const busy = document.hidden || Boolean(document.querySelector('dialog[open], cart-drawer.active, details-modal details[open], [aria-modal="true"][aria-hidden="false"]'));
        if (busy || !image.complete) {
          if (++attempts < 20) window.setTimeout(showWhenReady, 1000);
          return;
        }
        if (!editor && Date.now() - readSeen() < frequency) return;
        try {
          const scrollbar = window.innerWidth - document.documentElement.clientWidth;
          oldOverflow = document.body.style.overflow; oldPadding = document.body.style.paddingRight;
          const padding = Number.parseFloat(getComputedStyle(document.body).paddingRight) || 0;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          if (scrollbar > 0) document.body.style.paddingRight = `${padding + scrollbar}px`;
          styleApplied = true;
          markSeen();
        } catch (_) {}
      }
      if (image) image.loading = 'eager';
      window.setTimeout(showWhenReady, editor ? 200 : delay);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e11-youtube-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('e11-youtube-reviews')) {
    customElements.define('e11-youtube-reviews', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-video-id]').forEach((button) => {
          if (button.dataset.ready) return;
          button.dataset.ready = 'true';
          button.hidden = false;
          const fallback = button.parentElement.querySelector('.e11-yt__fallback');
          if (fallback) fallback.hidden = true;
          button.addEventListener('click', () => {
            const frame = document.createElement('iframe');
            frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(button.dataset.videoId) + '?autoplay=1&playsinline=1&rel=0';
            frame.title = button.dataset.videoTitle;
            frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            frame.allowFullscreen = true;
            frame.referrerPolicy = 'strict-origin-when-cross-origin';
            button.parentElement.appendChild(frame);
            button.hidden = true;
            frame.focus();
          }, { once: true });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immersive-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('immersive-video-hero')) {
    customElements.define('immersive-video-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.player = this.querySelector('.ivh__player');
        this.content = this.querySelector('.ivh__content');
        this.playButton = this.querySelector('.ivh__play');
        this.background = this.querySelector('.ivh__background');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const syncMotion = () => {
          if (this.motion.matches || this.classList.contains('is-playing')) this.background?.pause();
          else this.background?.play().catch(() => {});
        };
        syncMotion();
        this.motion.addEventListener('change', syncMotion, options);
        this.querySelectorAll('[data-play]').forEach(button => button.addEventListener('click', () => {
          this.trigger = button;
          this.openVideo();
        }, options));
        this.querySelector('.ivh__close').addEventListener('click', () => this.closeVideo(), options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.player.hidden) this.closeVideo();
        }, options);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(this)) this.cleanup();
        }, options);
      }
      openVideo() {
        const id = this.dataset.videoId;
        if (!id || !/^[\w-]{11}$/.test(id)) return;
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
        frame.title = this.playButton.getAttribute('aria-label');
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        this.querySelector('.ivh__frame').replaceChildren(frame);
        this.player.hidden = false;
        this.content.inert = true;
        this.background?.pause();
        this.animation = requestAnimationFrame(() => {
          this.classList.add('is-playing');
          this.querySelector('.ivh__close').focus();
        });
      }
      closeVideo() {
        cancelAnimationFrame(this.animation);
        this.classList.remove('is-playing');
        this.querySelector('.ivh__frame').replaceChildren();
        this.player.hidden = true;
        this.content.inert = false;
        if (!this.motion.matches) this.background?.play().catch(() => {});
        (this.trigger || this.playButton)?.focus();
      }
      cleanup() {
        cancelAnimationFrame(this.animation);
        this.controller?.abort();
        this.controller = null;
        this.querySelector('.ivh__frame')?.replaceChildren();
        this.classList.remove('is-playing');
        if (this.player) this.player.hidden = true;
        if (this.content) this.content.inert = false;
        this.background?.pause();
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
